import type { ContestType, Sport } from '@betterpool/api-types/contests-service';
import { useCallback } from 'react';

import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';

const featureFlag = FEATURE.ENABLE_NEW_GAMESHELL_V2_FOR_CONTEST_TYPE;

export const useIsGamecenterEnabled = (contestType?: ContestType, sport?: Sport) => {
  const { isSettled, treatments } = useTreatments([featureFlag]);
  const { config } = treatments?.[featureFlag] ?? {};

  const isEnabled = sport && contestType ? config?.[contestType]?.includes(sport) : null;

  return {
    isSettled: isSettled && !!contestType && !!sport,
    isEnabled,
  };
};

export const useIsGamecenterEnabledCallback = () => {
  const { isSettled, treatments } = useTreatments([featureFlag]);
  const { config } = treatments?.[featureFlag] ?? {};

  return useCallback(
    (contestType?: ContestType, sport?: Sport) => {
      if (!isSettled || !contestType || !sport) return false;

      return config?.[contestType]?.includes(sport);
    },
    [isSettled, config]
  );
};
